import { FixedContainer, GridContainer } from "src/style"
import {ReactComponent as SupportImg} from 'src/assets/img/support-icon.svg'

export const SupportIcon = () => {
    return (
        <FixedContainer bottom='5' right='5' zIndex="3">
                <GridContainer 
                    width='7' height='7' radius='1.25' bgColor='#0D968F'
                    className='support-container'
                >
                    {/* <ImHeadphones style={{fontSize: '3.5rem', color: '#ffffff'}} /> */}
                    <SupportImg className='icon-component'/>
                </GridContainer>
            </FixedContainer>
    )
}